var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subject",
    class: {
      'subject--is-expanded': _vm.computedIsExpanded
    }
  }, [_c('div', {
    staticClass: "subject__index d-flex align-items-center"
  }, [_c('span', {
    staticClass: "subject__sequence"
  }, [_vm._v("第 " + _vm._s(_vm.index + 1) + " 題")]), _c('i', {
    staticClass: "mdi mdi-18px ml-3",
    class: _vm.subjectTypeIcon(_vm.type)
  })]), _c('div', {
    staticClass: "subject__title"
  }, [_c('b-form-input', {
    ref: "titleInputRef",
    class: {
      'is-invalid': _vm.validate && _vm.titleValidState === false
    },
    attrs: {
      "disabled": _vm.isReadOnly || false === _vm.titleIsEditable,
      "state": _vm.validate ? _vm.titleValidState : null,
      "placeholder": _vm.validate && _vm.titleValidState === false ? _vm.validationMessage : ''
    },
    on: {
      "input": function input(value) {
        return _vm.$emit('update:title', value);
      }
    },
    model: {
      value: _vm.vModelForTitle,
      callback: function callback($$v) {
        _vm.vModelForTitle = $$v;
      },
      expression: "vModelForTitle"
    }
  })], 1), _c('div', {
    staticClass: "subject__sorting d-flex align-items-center"
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-drag-horizontal cursor-grab subject-layout-drag-handler"
  }), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveUpIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('top');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-collapse-up"
  }), _vm._v(" 移至最頂 ")]), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveUpIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('up');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-up"
  }), _vm._v(" 上移 ")]), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveDownIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('down');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-down"
  }), _vm._v(" 下移 ")]), _c('b-button', {
    staticClass: "ml-2 subject__button",
    class: {
      'subject__button--disabled': _vm.moveDownIsDisabled || _vm.isReadOnly
    },
    attrs: {
      "variant": "secondary",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('bottom');
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-collapse-down"
  }), _vm._v(" 移至最底 ")])], 1), _c('div', {
    staticClass: "subject__deletion d-flex align-items-center"
  }, [_vm.isDeletable ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": "danger",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.confirmForDeletion
    }
  }, [_c('span', {
    staticClass: "mdi mdi-delete"
  }), _vm._v(" 移除 ")]) : _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": "primary",
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "mdi mdi-star"
  }), _vm._v(" 必要 ")])], 1), _c('div', {
    staticClass: "subject__options",
    class: {
      'd-none': !_vm.computedIsExpanded
    }
  }, [_vm.placeholderIsVisible ? _c('b-input-group', {
    staticClass: "subject__advance-option-input"
  }, [_c('b-input-group-prepend', [_c('span', {
    staticClass: "mdi mdi-information-outline"
  })]), _c('b-form-input', {
    ref: "placeholderRef",
    on: {
      "input": function input(value) {
        return _vm.$emit('update:placeholder', value);
      }
    },
    model: {
      value: _vm.vModelForPlaceholder,
      callback: function callback($$v) {
        _vm.vModelForPlaceholder = $$v;
      },
      expression: "vModelForPlaceholder"
    }
  })], 1) : _vm._e(), _vm.memoIsVisible ? _c('b-input-group', {
    staticClass: "subject__advance-option-input"
  }, [_c('b-input-group-prepend', [_c('span', {
    staticClass: "mdi mdi-comment-text-outline"
  })]), _c('b-form-input', {
    ref: "memoRef",
    on: {
      "input": function input(value) {
        return _vm.$emit('update:memo', value);
      }
    },
    model: {
      value: _vm.vModelForMemo,
      callback: function callback($$v) {
        _vm.vModelForMemo = $$v;
      },
      expression: "vModelForMemo"
    }
  })], 1) : _vm._e(), _vm.locationIsVisible ? _c('b-input-group', {
    staticClass: "subject__advance-option-input"
  }, [_c('b-input-group-prepend', [_c('span', {
    staticClass: "mdi mdi-image-filter-center-focus-weak"
  })]), _c('div', {
    staticClass: "subject__advance-option-content-wrapper"
  }, [_c('span', [_vm._v("分頁：")]), _c('b-form-select', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "options": _vm.pageCandidates
    },
    on: {
      "input": _vm.handlePageChanges
    },
    model: {
      value: _vm.vModelForPage,
      callback: function callback($$v) {
        _vm.vModelForPage = $$v;
      },
      expression: "vModelForPage"
    }
  }), _c('span', [_vm._v("，分區：")]), _c('b-form-select', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "options": _vm.sectioncandidates
    },
    on: {
      "input": _vm.handleSectionChanges
    },
    model: {
      value: _vm.vModelForSection,
      callback: function callback($$v) {
        _vm.vModelForSection = $$v;
      },
      expression: "vModelForSection"
    }
  })], 1)], 1) : _vm._e(), _vm.visibleConditionIsVisible ? _vm._l(_vm.displayConditions, function (conditionIndex) {
    return _c('b-input-group', {
      key: conditionIndex,
      staticClass: "subject__advance-option-input"
    }, [_c('b-input-group-prepend', [_c('span', {
      staticClass: "mdi mdi-lightbulb-on-outline"
    })]), _c('div', {
      staticClass: "subject__advance-option-content-wrapper"
    }, [_c('span', [_vm._v("當")]), _c('b-form-select', {
      staticStyle: {
        "max-width": "160px"
      },
      attrs: {
        "options": _vm.visibleConditionFieldCandidates
      },
      on: {
        "input": function input(val) {
          return _vm.handleVisibleConditionFieldChanges(conditionIndex - 1, val);
        }
      },
      model: {
        value: _vm.conditionList[conditionIndex - 1].field_id,
        callback: function callback($$v) {
          _vm.$set(_vm.conditionList[conditionIndex - 1], "field_id", $$v);
        },
        expression: "conditionList[conditionIndex - 1].field_id"
      }
    }), _c('span', [_vm._v("為")]), _c('b-form-select', {
      staticStyle: {
        "max-width": "160px"
      },
      attrs: {
        "options": _vm.visibleConditionValueCandidates
      },
      on: {
        "input": function input(val) {
          return _vm.handleVisibleConditionOptionChanges(conditionIndex - 1, val);
        }
      },
      model: {
        value: _vm.conditionList[conditionIndex - 1].value,
        callback: function callback($$v) {
          _vm.$set(_vm.conditionList[conditionIndex - 1], "value", $$v);
        },
        expression: "conditionList[conditionIndex - 1].value"
      }
    }), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-success"
      },
      on: {
        "click": function click($event) {
          return _vm.createCondition(conditionIndex - 1);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-plus"
    }), _vm._v(" 增加 ")]), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-danger",
        "disabled": _vm.isOnlyOneCondition()
      },
      on: {
        "click": function click($event) {
          return _vm.removeCondition(conditionIndex - 1);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-remove"
    }), _vm._v(" 移除 ")])], 1)], 1);
  }) : _vm._e(), _vm.vModelForValidationRules ? _c('span', {
    staticClass: "subject__validation-rule mb-3"
  }, [_vm._v(" 格式：" + _vm._s(_vm.deepGet(_vm.allValidationRules, "[".concat(_vm.type, "][").concat(_vm.vModelForValidationRules, "].title"), '')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "subject__toggle-wrapper"
  }, [_c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForRequired ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        _vm.vModelForRequired = !_vm.vModelForRequired;
        _vm.$emit('update:required', _vm.vModelForRequired);
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-star-outline"
  }), _vm._v(" 必填 ")]), Object.keys(_vm.allValidationRules).includes(_vm.type) ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForValidationRules ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        _vm.validationModalIsVisible = true;
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-altimeter"
  }), _vm._v(" 格式驗證 ")]) : _vm._e(), _vm.hasPlaceholder ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.placeholderIsVisible ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.togglePlaceholderValue
    }
  }, [_c('span', {
    staticClass: "mdi mdi-information-outline"
  }), _vm._v(" 提示文字 ")]) : _vm._e(), _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.memoIsVisible ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleMemoValue
    }
  }, [_c('span', {
    staticClass: "mdi mdi-comment-text-outline"
  }), _vm._v(" 填寫說明 ")]), _vm.type === 'text' ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForAssignToCustomerData ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        _vm.dataAssignmentModalIsVisible = true;
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-link-variant"
  }), _vm._v(" 欄位自動預填 ")]) : _vm._e(), _vm.type === 'text' ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForSaveToCustomerData ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": function click($event) {
        _vm.saveToCustomerDataModalIsVisible = true;
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-content-save-outline"
  }), _vm._v(" 自動更新客資 ")]) : _vm._e(), _vm.locationIsEnabled ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.locationIsVisible ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleLocation
    }
  }, [_c('span', {
    staticClass: "mdi mdi-image-filter-center-focus-weak"
  }), _vm._v(" 顯示區域 ")]) : _vm._e(), _vm.visibleConditionIsEnabled ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.visibleConditionIsVisible ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleVisibleCondition
    }
  }, [_c('span', {
    staticClass: "mdi mdi-lightbulb-on-outline"
  }), _vm._v(" 觸發顯示 ")]) : _vm._e(), _vm.formType === 'booking' ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForDashboardOnly ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleDashboardOnly
    }
  }, [_c('span', {
    staticClass: "mdi mdi-laptop"
  }), _vm._v(" 僅限後台編輯 ")]) : _vm._e(), _vm.formType === 'collection' ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForMainDisplay ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleMainDisplay
    }
  }, [_c('span', {
    staticClass: "mdi mdi-label-outline"
  }), _vm._v(" 下拉選單以這欄位當作顯示文字 ")]) : _vm._e(), ['booking', 'preorder'].includes(_vm.formType) ? _c('b-button', {
    staticClass: "subject__button",
    attrs: {
      "variant": _vm.vModelForListHidden ? 'primary' : 'secondary',
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.toggleListHidden
    }
  }, [_c('span', {
    staticClass: "mdi mdi-eye-off"
  }), _vm._v(" 隱藏於列表欄位 ")]) : _vm._e()], 1)], 2), _c('div', {
    staticClass: "subject__preview",
    class: {
      'd-none': !_vm.computedIsExpanded
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("預覽：")]), _c('b-card', {
    staticClass: "rounded rounded-lg subject__preview-box"
  }, [_vm._t("preview")], 2)], 1), _c('div', {
    staticClass: "subject__slot",
    class: {
      'd-none': !_vm.computedIsExpanded
    }
  }, [_vm._t("default")], 2), _vm.expandButtonIsVisible ? _c('div', {
    staticClass: "subject__expand"
  }, [_c('b-button', {
    staticClass: "d-flex align-items-center justify-content-center w-100 border-0 bg-white",
    on: {
      "click": _vm.toggleDetails
    }
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-chevron-down"
  })])], 1) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "格式驗證",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              _vm.validationModalIsVisible = false;
            }
          }
        }, [_vm._v(" 確定 ")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.validationModalIsVisible,
      callback: function callback($$v) {
        _vm.validationModalIsVisible = $$v;
      },
      expression: "validationModalIsVisible"
    }
  }, [[_c('b-form-group', {
    attrs: {
      "label": "選擇驗證規則"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.validationRuleOptions
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('update:validationRules', _vm.vModelForValidationRules);
      }
    },
    model: {
      value: _vm.vModelForValidationRules,
      callback: function callback($$v) {
        _vm.vModelForValidationRules = $$v;
      },
      expression: "vModelForValidationRules"
    }
  })], 1)]], 2), _c('b-modal', {
    attrs: {
      "title": "欄位自動預填",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              _vm.dataAssignmentModalIsVisible = false;
            }
          }
        }, [_vm._v(" 確定 ")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dataAssignmentModalIsVisible,
      callback: function callback($$v) {
        _vm.dataAssignmentModalIsVisible = $$v;
      },
      expression: "dataAssignmentModalIsVisible"
    }
  }, [[_c('b-form-group', {
    attrs: {
      "label": "請選擇自動預填的欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.assignableCustomerDataOptions
    },
    on: {
      "input": _vm.handleAssignToCustomerDataChange
    },
    model: {
      value: _vm.vModelForAssignToCustomerData,
      callback: function callback($$v) {
        _vm.vModelForAssignToCustomerData = $$v;
      },
      expression: "vModelForAssignToCustomerData"
    }
  }), _c('span', {
    staticClass: "text-muted small mt-2 d-block"
  }, [_vm._v(" ※ 設定後，若系統已有此客戶的資料，將在預約時自動預填。 ")])], 1), _vm.vModelForAssignToCustomerData === 'custom' ? _c('b-form-group', {
    attrs: {
      "label": "請輸入自訂欄位名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "例如: mobile_phone 或 extra.fav_store_name"
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('update:assignToCustomerData', _vm.vModelForCustomFieldName);
      }
    },
    model: {
      value: _vm.vModelForCustomFieldName,
      callback: function callback($$v) {
        _vm.vModelForCustomFieldName = $$v;
      },
      expression: "vModelForCustomFieldName"
    }
  }), _c('span', {
    staticClass: "text-muted small mt-2 d-block"
  }, [_vm._v(" ※ 支援層級路徑，例如: extra.fav_store_name ")])], 1) : _vm._e()]], 2), _c('b-modal', {
    attrs: {
      "title": "自動更新客資",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              _vm.saveToCustomerDataModalIsVisible = false;
            }
          }
        }, [_vm._v(" 確定 ")])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.saveToCustomerDataModalIsVisible,
      callback: function callback($$v) {
        _vm.saveToCustomerDataModalIsVisible = $$v;
      },
      expression: "saveToCustomerDataModalIsVisible"
    }
  }, [[_c('b-form-group', {
    attrs: {
      "label": "請選擇要儲存至客戶資料的欄位"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.savableCustomerDataOptions
    },
    on: {
      "input": _vm.handleSaveToCustomerDataChange
    },
    model: {
      value: _vm.vModelForSaveToCustomerData,
      callback: function callback($$v) {
        _vm.vModelForSaveToCustomerData = $$v;
      },
      expression: "vModelForSaveToCustomerData"
    }
  }), _c('span', {
    staticClass: "text-muted small mt-2 d-block"
  }, [_vm._v(" ※ 設定後，客戶填寫的內容將自動儲存至指定的客戶資料欄位。 ")])], 1), _vm.vModelForSaveToCustomerData === 'custom' ? _c('b-form-group', {
    attrs: {
      "label": "請輸入自訂欄位名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "例如: mobile_phone 或 extra.fav_store_name"
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('update:saveToCustomerData', _vm.vModelForSaveCustomFieldName);
      }
    },
    model: {
      value: _vm.vModelForSaveCustomFieldName,
      callback: function callback($$v) {
        _vm.vModelForSaveCustomFieldName = $$v;
      },
      expression: "vModelForSaveCustomFieldName"
    }
  }), _c('span', {
    staticClass: "text-muted small mt-2 d-block"
  }, [_vm._v(" ※ 支援層級路徑，例如: extra.fav_store_name ")])], 1) : _vm._e()]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }